export default __webpack_public_path__ + "static/bg-1-old-be680865ff56ebff0aa05b403b461698.jpg";